var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopularRegions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17564",
    "data-name": "Group 17564",
    transform: "translate(-919 -628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(925 630)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    y2: 7.677,
    transform: "translate(3.706 7.413)",
    fill: "none",
    stroke: "#556080",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    cx: 3.706,
    cy: 3.706,
    rx: 3.706,
    ry: 3.706,
    transform: "translate(0)",
    fill: "#c22127"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 0.794,
    cy: 0.794,
    rx: 0.794,
    ry: 0.794,
    transform: "translate(1.588 1.853)",
    fill: "#c22127"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(919 628)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularRegions);
export default __webpack_public_path__ + "static/media/popular_regions.39f41d6a1d41268cd827cc68084621d3.svg";
export { ForwardRef as ReactComponent };